module.exports = __webpack_public_path__ + "img/verification-img.88cedf1f.png";